// types
import { PayProps } from 'types/pay';
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from '../index';
import axios from 'utils/axios';

// initial state
const initialState: PayProps = {
    error: null,
    methods: [],
    priceArr: []
};

// ==============================|| SLICE - MENU ||============================== //

const pay = createSlice({
    name: 'pay',
    initialState,
    reducers: {
        // has error
        hasError(state, action) {
            state.error = action.payload;
        },
        // get dashboard menu
        getMethodsSuccess(state, action) {
            state.methods = action.payload;
        },
        getPriceListSuccess(state, action) {
            state.priceArr = action.payload;
        }
    }
});

export default pay.reducer;

export const { getPriceListSuccess } = pay.actions;

export function getMethods(lang: string) {
    return async () => {
        try {
            const { data } = await axios.get(`/pay/pay_methods`);
            dispatch(pay.actions.getMethodsSuccess(data.method));
        } catch (error) {
            dispatch(pay.actions.hasError(error));
        }
    };
}

export function getPriceList(uid: string | number) {
    return async () => {
        try {
            const { data } = await axios.get(`/pay/get_price_list?uid=${uid}`);
            // const { data } = await axios.get(`/pay/get_price_list_debug?debug=0.95`);

            dispatch(pay.actions.getPriceListSuccess(data));
        } catch (error) {
            dispatch(pay.actions.hasError(error));
        }
    };
}
